import { BaseListModel } from "../base/base-list-model";
import { UserModel } from "./user.model";

export const UsersListModel = BaseListModel(UserModel).named("Users");
